import { defineComponent as _defineComponent } from 'vue';
import { useCurrentLocation } from '@/use/current_location';
export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {
    const {
      getCurrentLocation
    } = useCurrentLocation();
    getCurrentLocation();
    return {
      __sfc: true,
      getCurrentLocation
    };
  }
});